module.exports = __webpack_public_path__ + "img/default.77005db1.svg";